The input parameter for the `postPositionFromDraft` mutation.
